import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ProductState } from './community-product.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState slice
export const selectProductState = createFeatureSelector<AppState, ProductState>('communityProducts');

// Selector for all products (unfiltered)
// Returns all community products or an empty array as a fallback
export const selectAllCommunityProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.communityProducts || [] // Ensure fallback for safety
);

// Selector for the loading state
// Indicates whether products are currently being loaded
export const selectLoading = createSelector(
  selectProductState,
  (state: ProductState) => state.loading
);

// Selector for the error state
// Retrieves any errors that occurred during product loading
export const selectError = createSelector(
  selectProductState,
  (state: ProductState) => state.error
);
